import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';

/**
 * ページコンポーネント群
 */
export const DASHBOARD_PAGES = [DashboardPageComponent];
